import { render, staticRenderFns } from "./Yogashow.vue?vue&type=template&id=525f87c7&"
import script from "./Yogashow.vue?vue&type=script&lang=js&"
export * from "./Yogashow.vue?vue&type=script&lang=js&"
import style0 from "./Yogashow.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Flodging-show&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports